(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elogbooksLocationLinks', ElogbooksLocationLinks);

    function ElogbooksLocationLinks() {
        return {
            restrict: 'E',
            scope: {
                link: '=',
                siteLink: '=',
                buildingLink: '=',
                floorLink: '='
            },
            transclude: true,
            templateUrl: '/modules/directives/links/site/location/location.html',
            controller: function ($scope, userManager) {

                $scope.type = null;

                switch (true) {
                    case userManager.hasPermission('user_permission_view_sites'):
                        $scope.type = 'admin';
                        break;
                    case true:
                        $scope.type = 'user';
                        break;
                }
            }
        };
    };

})();
